import { EntityLabel } from '@esg/esg-global-types';

export const meter_entity_label: EntityLabel = {
  one: 'Meter',
  many: 'Meters'
};
